import styled from '@emotion/styled/macro';
import { Icon } from '@mdi/react';
import { BaseButton, Variables } from '../base';
import { TitleCard } from '../card';
import { styledTitleCardSectionTitle } from '../claim-details/claim-section.styles';

export const StyledTitleCard = styled(TitleCard)`
    ${styledTitleCardSectionTitle}
    justify-content: space-between;
    max-width: 100%;
    margin: 0 0 24px;
    border-radius: 12px;
    background-color: ${Variables.Swatches.Gray1};
`;

export const HeaderToggleButton = styled(BaseButton)`
    min-width: auto;
    height: 32px;
    width: 32px;
    padding: 0;
    border-color: transparent;
    background: none;

    &:hover {
        border: solid 1px ${Variables.Colors.nx8};
        background: ${Variables.Colors.n5};
    }
`;

export const HeaderToggleIcon = styled(Icon)`
    fill: ${Variables.Colors.p300};
`;

export const CardBody = styled.div<{ $expanded?: boolean }>`
    display: flex;
    flex-direction: column;
    flex: 1 1 100%;
    gap: 20px;
    overflow-x: auto;
    padding: ${props => (props.$expanded ? '24px 24px 24px' : '24px')};
`;

export const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 240px;
    padding: 48px 24px;
`;

export const ErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 48px 24px;
    min-height: 240px;
`;

export const ErrorMessage = styled.p`
    margin: 0;
    max-width: 480px;
    font-size: 16px;
    line-height: 1.4;
    color: ${Variables.ThemeLight.TextMedium};
    text-align: center;
`;

export const RetryButton = styled(BaseButton)`
    min-width: 120px;
`;
